import React from "react";
import PropTypes from "prop-types";
import Typography from "material-ui/Typography";
import Snackbar from "material-ui/Snackbar";

import styles from "./CenteredForm.scss";

const Centered = ({
  children,
  title,
  handleOnSubmit,
  snackbarMessage,
  style,
}) => (
  <section className={styles.formContainer} style={style}>
    <Typography type="display1" className="mb3" align="center">
      <span id={styles.TitleFormContainer}>{title}</span>
    </Typography>
    <form autoComplete="off" className={styles.form} onSubmit={handleOnSubmit}>
      {children}
    </form>
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={typeof snackbarMessage.message !== "undefined"}
      snackbarcontentprops={{
        "aria-describedby": "message-id",
      }}
      message={<span id="message-id">{snackbarMessage.message}</span>}
      className={styles.snackbar}
    />
  </section>
);

Centered.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  handleOnSubmit: PropTypes.func.isRequired,
  snackbarMessage: PropTypes.objectOf(PropTypes.any).isRequired,
  style: PropTypes.object,
};

export default Centered;



// WEBPACK FOOTER //
// ./src/pages/utils/form/CenteredForm.jsx